<script>
import AImage from "@components/atoms/a-image.vue";
import AButton from "@components/atoms/a-button.vue";
import stringSanitize from "@utils/string-sanitize";
import { mapGetters } from "vuex";
import { getRouteNameParsed } from "@utils/getRouteNameParsed";

export default {
  name: "OFooter",
  components: {
    AImage,
    AButton,
  },
  props: {
    imageSecurity: {
      type: Object,
      default: () => ({
        images: [
          {
            name: "Site Seguro",
            url: "/img/ssl.svg",
          },
          {
            name: "Google Site Seguro",
            url: "/img/google-site-seguro.svg",
          },
          {
            name: "Site 100% Seguro",
            url: "/img/site-seguro.svg",
          },
        ],
      }),
    },
  },
  methods: {
    getRouteNameFromURL() {
      const url = new URL(window.location.href);
      const pathName = url.pathname;
      return getRouteNameParsed(pathName, true);
    },
    handleClick() {
      let description = stringSanitize(this.buttonLabelName);
      if (
        this.plano &&
        this.plano.dados !== undefined &&
        this.plano.price !== undefined
      )
        description = `${description}:${stringSanitize(this.plano.dados)}:${
          this.plano.price
        }`;
      // console.log(this.plano);
      this.$gtm.sendInteractionEvent("user_interaction", {
        component: "button",
        description,
        action: "click",
        step: this.getRouteNameFromURL(),
      });
    },
    handleSubmit() {
      this.$store.dispatch("forms/startSubmit", this.$route.name);
      this.handleClick();
    },
  },
  computed: {
    ...mapGetters({
      plano: "order/getPlanToFooter",
    }),
    buttonLabelName() {
      return this.$route.name === "Pagamento"
        ? "Finalizar"
        : this.$route.name === "ComplementarDados"
        ? "Confirmar"
        : "Avançar";
    },
  },
};
</script>

<template lang="pug">
  footer(class="flex flex-col items-center justify-between px-4 md:flex-row-reverse")
    AButton(success class="mb-6 md:mb-0" @click="handleSubmit" ref="buttonSubmit") {{buttonLabelName}}
    AImage(:paths="imageSecurity.images" class="flex items-center justify-center" classList="mx-2 w-20 md:h-7 md:w-32")
</template>
